var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "mb-1" }, [
      _c("strong", [
        _vm._v(
          _vm._s(_vm.$t("message.no_datetime_booking.select_service_location"))
        )
      ])
    ]),
    _vm._v(" "),
    _vm.userPlaces.length > 0
      ? _c(
          "section",
          [
            _vm._l(_vm.userPlaces, function(userPlace) {
              return _c("div", [
                _c("div", { staticClass: "card" }, [
                  _c("div", { staticClass: "card-body text-left" }, [
                    _c("div", { staticClass: "text-sm" }, [
                      _c("strong", [_vm._v(_vm._s(userPlace.place_name))])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "text-secondary text-sm mt-1" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(userPlace.address) +
                          "\n            "
                      ),
                      userPlace.sub_district
                        ? _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm._f("multiLangName")(userPlace.sub_district)
                              )
                            )
                          ])
                        : _vm._e(),
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm._f("multiLangName")(userPlace.district)) +
                          "\n            " +
                          _vm._s(
                            _vm._f("multiLangName")(userPlace.address_province)
                          ) +
                          "\n            "
                      ),
                      userPlace.sub_district
                        ? _c("span", [
                            _vm._v(_vm._s(userPlace.sub_district.zip_code))
                          ])
                        : _vm._e()
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "d-flex justify-content-end pr-3 pb-3" },
                    [
                      _c("div", [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-info px-3",
                            on: {
                              click: function($event) {
                                return _vm.selectUserPlace(userPlace)
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.$t("message.company_address.choose")
                                ) +
                                "\n            "
                            )
                          ]
                        )
                      ])
                    ]
                  )
                ])
              ])
            }),
            _vm._v(" "),
            _vm.canLoadMore
              ? _c("div", { staticClass: "pt-3" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-outline-info btn-block",
                      attrs: { disabled: _vm.isLoading },
                      on: {
                        click: function($event) {
                          return _vm.loadMoreUserPlaces()
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm.isLoading
                              ? _vm.$t("message.button.loading")
                              : _vm.$t("message.button.load_more")
                          ) +
                          "\n      "
                      )
                    ]
                  )
                ])
              : _vm._e()
          ],
          2
        )
      : _c("section", { staticClass: "text-center" }, [
          _vm.isLoading
            ? _c("div", [_c("loader")], 1)
            : _c("div", [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.$t("message.professional.no_service_provider")) +
                    "\n    "
                )
              ])
        ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-40eb9e90", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40eb9e90","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/order/components/SelectUserPlace.vue
// module id = 1768
// module chunks = 0